
(() => {
  const properties = window.cgInvitedProperties || {};
  const params = new URLSearchParams(window.location.search);
  const token = params.get("property");

  const propertyName =
    token && Object.prototype.hasOwnProperty.call(properties, token)
      ? properties[token]
      : "";

  const validInvitation = Boolean(propertyName);

  const propertySelector =
    'input[id^="custom#invited_property"]';

  const privacyURL =
    "https://shopcounterguard.com/policies/privacy-policy";

  function getForm() {
    return document.querySelector("shopify-forms-embed");
  }

  function showInvalidInvitation(form) {
    if (!document.getElementById("cg-invalid-invite-style")) {
      const style = document.createElement("style");
      style.id = "cg-invalid-invite-style";
      style.textContent = `
        shopify-forms-embed {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    }

    if (!document.getElementById("cg-invite-message")) {
      const message = document.createElement("div");
      message.id = "cg-invite-message";
      message.style.cssText =
        "max-width:480px;margin:40px auto;" +
        "padding:24px;text-align:center;line-height:1.6;";

      const heading = document.createElement("h2");
      heading.textContent = "Invitation Required";

      const description = document.createElement("p");
      description.textContent =
        "This product testing program requires a valid, " +
        "active invitation. Please use the link provided " +
        "by your participating property.";

      message.append(heading, description);
      form.insertAdjacentElement("beforebegin", message);
    }
  }

  function populateProperty(root) {
    const field = root.querySelector(propertySelector);
    if (!field) return;

    if (field.value !== propertyName) {
      const setter = Object.getOwnPropertyDescriptor(
        HTMLInputElement.prototype,
        "value"
      )?.set;

      if (setter) {
        setter.call(field, propertyName);
      } else {
        field.value = propertyName;
      }

      field.dispatchEvent(
        new Event("input", { bubbles: true, composed: true })
      );

      field.dispatchEvent(
        new Event("change", { bubbles: true, composed: true })
      );
    }

    field.readOnly = true;
  }

  function fixPrivacyPolicyLink(root) {
    const link = root.querySelector(
      'a[title="Privacy Policy"]'
    );

    if (!link) return;

    if (link.getAttribute("href") !== privacyURL) {
      link.href = privacyURL;
    }

    link.target = "_blank";
    link.rel = "noopener noreferrer";
  }

  function initialize(form) {
    if (!validInvitation) {
      showInvalidInvitation(form);
      return;
    }

    const root = form.shadowRoot;
    if (!root) return;

    let updating = false;

    function synchronize() {
      if (updating) return;
      updating = true;

      try {
        populateProperty(root);
        fixPrivacyPolicyLink(root);
      } finally {
        updating = false;
      }
    }

    synchronize();

    const observer = new MutationObserver(synchronize);

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  }

  const form = getForm();

  if (form) {
    if (form.shadowRoot || !validInvitation) {
      initialize(form);
    } else {
      const observer = new MutationObserver(() => {
        if (form.shadowRoot) {
          observer.disconnect();
          initialize(form);
        }
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  } else {
    const observer = new MutationObserver(() => {
      const embeddedForm = getForm();

      if (embeddedForm) {
        observer.disconnect();
        initialize(embeddedForm);
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
